import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { push } from 'react-router-redux';
import { actionTypes } from '../constants';
import fetch from '../utils/fetch';
import awsconfig from '../awsconfig';
import bluebird from 'bluebird';

const excludedFields = [
  '_id',
  'createdAt',
  'updatedAt',
];

var Api = {
    fetchAccident: async (id) => {
        console.log('fetchAccident begin')
        let response = await fetch({
            url: `${awsconfig.officeApi}/accidents/${id}`,
            method: 'get',
        })
        return response.result;
    },
    fetchAccidents: async () => {
        console.log('fetchAccidents begin')
        let response = await fetch({
            url: `${awsconfig.officeApi}/accidents`,
            method: 'get',
        })
        return response.result;
    },
    updateAccident: async (id, data) => {
        console.log('updateAccident begin')
        // create a copy before deleting excluded keys
        var clone = JSON.parse(JSON.stringify(data));
        // remove keys that API will not accept
        Object.keys(clone).map(key => {
          if (excludedFields.includes(key)) {
            delete clone[key];
          }
        });
        // include any required fields' defaults
        clone = {
          ...requiredFieldsWithDefaults,
          ...clone  // this will overwrite defaults
        }
        let response = await fetch({
            url: `${awsconfig.officeApi}/accidents/${id}`,
            data: clone,
            method: 'put',
        })
        return response.result;
    },
    createAccident: async (data) => {
        console.log('createAccident begin')

        // normalize to Array type for backend API
        if (!Array.isArray(data)) {
            data = [data];
        }

        // create a copy before deleting excluded keys
        const accidents = JSON.parse(JSON.stringify(data));

        // remove keys that API will not accept
        for(var i=0; i<accidents.length; i++){
            let clone = accidents[0];
            Object.keys(clone).map(key => {
              if (excludedFields.includes(key)) {
                delete clone[key]; // array is mutable so affects array in-place
              }
            });
        }

        // POST to backend API
        let response = await fetch({
            url: `${awsconfig.officeApi}/accidents`,
            data: accidents,
            method: 'post',
        })
        return response.result;
    },
    // submitAccidentToVCA: async (id) => {
    //     console.log('submitAccidentToVCA begin')
    //     let response = await fetch({
    //         url: `${awsconfig.officeApi}/accidents/${id}/vca`,
    //         data: {},
    //         method: 'post',
    //     })
    //     return response.result;
    // },
}

function* fetchAccident(action) {
    try {
        yield put({type: actionTypes.SPINNING_START})
        const accident = yield call(Api.fetchAccident, action.id);
        yield put({type: actionTypes.ACCIDENTS_FETCH_ONE_SUCCESS, detail: accident});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'success',
            text: `Loaded 1 accident from the server.`
          }
        });
    } catch (e) {
        yield put({type: actionTypes.ACCIDENTS_FETCH_ONE_ERROR, error: e.message});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'error',
            text: e.message
          }
        });
    } finally {
        yield put({type: actionTypes.SPINNING_STOP})
    }
}

function* fetchAccidents(action) {
    try {
        yield put({type: actionTypes.SPINNING_START})
        const accidents = yield call(Api.fetchAccidents);
        yield put({type: actionTypes.ACCIDENTS_FETCH_ALL_SUCCESS, accidents: accidents});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'success',
            text: `Loaded ${accidents.length} accidents from the server.`
          }
        });
    } catch (e) {
        yield put({type: actionTypes.ACCIDENTS_FETCH_ALL_ERROR, error: e.message});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'error',
            text: e.message
          }
        });
    } finally {
        yield put({type: actionTypes.SPINNING_STOP})
    }
}

function* updateAccident(action) {
    try {
        yield put({type: actionTypes.SPINNING_START})
        const accident = yield call(Api.updateAccident, action.id, action.data);
        yield put({type: actionTypes.ACCIDENTS_UPDATE_ONE_SUCCESS, accident: accident});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'success',
            text: `Updated 1 accident.`
          }
        });
    } catch (e) {
        console.error(e)
        yield put({type: actionTypes.ACCIDENTS_UPDATE_ONE_ERROR, error: e.message});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'error',
            text: e.message
          }
        });
    } finally {
        yield put({type: actionTypes.SPINNING_STOP})
    }
}

function* createAccident(action) {
    try {
        yield put({type: actionTypes.SPINNING_START})
        yield put({type: actionTypes.ACCIDENTS_FETCH_ALL_SUCCESS, accidents: []});  // set blank since we are over-writing all during dev/QA @FIXME
        const createdAccidents = yield call(Api.createAccident, action.data); // returns array
        yield put({type: actionTypes.ACCIDENTS_CREATE_ONE_SUCCESS, detail: action.data});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'success',
            text: `Uploaded ${createdAccidents.length} State Data accidents.`
          }
        });
        yield put({type: actionTypes.ACCIDENTS_FETCH_ALL})
    } catch (e) {
        console.error(e)
        // handle SNACKBAR differently here to show fields
        var errorMessage = e.message;
        if(e.data && e.data.messages && _.get(e.data, 'messages[0].failed', null) !== null){
            let fields = [];
            e.data.messages.map(m=>{
                let field = _.get(m, 'path[1]', null);
                let text = _.get(m, 'failed', null);
                fields.push(
                    <li><strong>{field}</strong> is {text}</li>
                )
            })
            errorMessage = (
                <React.Fragment>
                    <div>
                        The following fields are incorrect:
                        {fields}
                    </div>
                </React.Fragment>
            );
        }
        console.log('snackbar Message', errorMessage)
        yield put({type: actionTypes.ACCIDENTS_CREATE_ONE_ERROR, error: e});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'error',
            text: errorMessage
          }
        });
    } finally {
        yield put({type: actionTypes.SPINNING_STOP})
    }
}

// const MAX_VCA_ATTEMPTS = 5;
// function* submitAccidentToVCA(action) {
//     let n_attempts = 0;
//     let accident;
//     try {
//         yield put({type: actionTypes.SPINNING_START})
//         accident = yield call(Api.submitAccidentToVCA, action.id);
//         yield put({
//           type: actionTypes.SNACKBAR,
//           snackbar: {
//             severity: 'success',
//             text: `Queued 1 accident to submit to VCA.`
//           }
//         });
//         while(n_attempts++ <= MAX_VCA_ATTEMPTS){
//           console.log('Waiting 2 seconds...');
//           yield call(bluebird.delay, 2000);  // wait 2 second
//           console.log('Attempting to fetch vcaClaimId...');
//           accident = yield call(Api.fetchAccident, action.id);
//           if(accident.vcaClaimId){
//             yield put({type: actionTypes.ACCIDENTS_FETCH_ONE_SUCCESS, detail: accident});
//             yield put({
//               type: actionTypes.SNACKBAR,
//               snackbar: {
//                 severity: 'success',
//                 text: `The accident was successfully received by VCA as new claim ID ${accident.vcaClaimId}.`
//               }
//             });
//             return;
//           }
//         }
//     } catch (e) {
//         console.error(e)
//         yield put({
//           type: actionTypes.SNACKBAR,
//           snackbar: {
//             severity: 'error',
//             text: e.message
//           }
//         });
//     } finally {
//         yield put({type: actionTypes.SPINNING_STOP})
//     }
// }

// throttle (e.g. for autocomplete search)
// takeEvery
// takeLatest
export const sagas = {
    fetchAccidentsSaga: takeLatest(actionTypes.ACCIDENTS_FETCH_ALL, fetchAccidents),
    fetchAccidentSaga: takeLatest(actionTypes.ACCIDENTS_FETCH_ONE, fetchAccident),
    updateAccidentSaga: takeLatest(actionTypes.ACCIDENTS_UPDATE_ONE, updateAccident),
    createAccidentSaga: takeLatest(actionTypes.ACCIDENTS_CREATE_ONE, createAccident),
    // submitAccidentToVCASaga: takeLatest(actionTypes.ACCIDENTS_SUBMIT_ONE_VCA, submitAccidentToVCA),
}
